export default {
    login: {
        email: "email",
        password: "senha",
        submit: "Entrar",
        submit_new_pass: "Salvar",
        label_pass: "Esqueci minha senha.",
        text_change_pass: "Olá, Verificamos que esse é o primeiro acesso a nossa plataforma, para entrar, crie uma senha pessoal e confirme.",
        text_forget_pass: "Confirme seu e-mail de registro para receber um link de reconfiguração de senha.",
        text_change_pass_code: "Olá, para reconfigurar sua senha de acesso, insira o código enviado por e-mail e então crie uma nova senha.",
        old_pass: "Senha Antiga",
        new_pass: "Nova Senha",
        code: "Codigo",
        new_pass_confirm: "Confirmar nova senha",
        alerts: {
            pass_diferent: "Por favor verifique se as senhas correspondem",
            new_pass: "Senha configurada! Por favor faça seu login novamente usando sua senha nova.",
            incorrect: "Login ou senha Incorretos!",
            mandatory: "Login e senha Obrigatórios!",
            success_change: "Sua senha foi aceita com sucesso! Você pode efetuar login.",
            success_email_sent_title: "E-mail enviado com sucesso!",
            success_email_sent_text: "Verifique sua caixa de entrada de e-mails. Você recebeu um código e um link para reconfigurar sua senha.",
        }
    },
    sideBar: {
        intelligentJourney: {
            title: "Intelligent Journey",
            links: ["Paineis", "Planejamento", "Relatorios","Gerar Relatório", "Demonstrativo financeiro","Cockpit"],
        },
        jobs: {
            title: "Jobs executados",
            links: ["Jobs executados"],
        },
        dataset: {
            title: "Upload",
            links: [ "Upload", "SFTP", "API"],
        },
        repositorio: {
            title: "Repositorio",
            links: ["Formato", "Master Data"],
        },
    },
    pedidos: {
        tabs: ["Dashboard", "Table"],
        status: {
            cards: [
                {
                    title: "Lead Time / Maximo",
                    subtitle: "Dias",
                    amount: 5,
                },
                {
                    title: "Lead Time / Minimo",
                    subtitle: "Dias",
                    amount: "3,2",
                },
                {
                    title: "Lead Time / Media",
                    subtitle: "Dias",
                    amount: "4,4",
                },
                {
                    title: "Predicao Media",
                    subtitle: "Dias",
                    amount: 4,
                },
                {
                    title: "Conversao",
                    subtitle: "Vol. Fat e Vol. Pedido",
                    amount: 1.408,
                },
            ],
            clientInput: {
                label: "Cliente",
                placeholder: "Todos clientes",
            },
            PeriodInput: {
                label: "Periodo",
            },
            dataFlow: {
                label: "Fluxo de Dados",
            },
        },
    },
    captura: {
        manual: {
            tabs: ["Upload"],
            title: "Envie aqui seus arquivos.",
            subtitle:
                "",
            uploadLabel: "Arraste e solte arquivos aqui ou clique aqui adicionar."
        },
        processando: {
            tabs: ["Processando"],
            title: "Acompanhamento dos arquivos em processamento.",
            subtitle:
                "Acompanhe por aqui os arquivos e seus progressos dentro da plataforma.",
            table_title: "Arquivos",
        },
        processando_table_header: {
            table: ["Status", "Agente", "Ultima atualização", "Usuário", "Arquivo", "Data do upload", "Menssagem"]
        }
    },
    repositorio: {
        formato: {
            tabs: ["Formato"],
            title: "TEXTO BR AQUI",
            subtitle:
                "COMO FUNCIONA EM BR AQUI.",
            table_title: "BASE FORMATOS",
            uploadLabel: "Drag and drop files here, or use the button to the right."
        },
        formato_table_header: {
            table: [
                "Arquivo", "Usuário", "Data Upload", "Baixar Arquivo"
            ]
        }
    }
}
